import { useIntl } from 'react-intl';
import { useFeesBySolutionContext } from 'sonata-platform-components';
import { Selector } from 'sonata-react-components';
import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';

import { AttributionModelValues } from './AttributionModelValues';
import { AttributionModelStyled } from './attributionModel.styled';

import type { SelectorOptionPropsInterface } from 'sonata-react-components';

function AttributionModel() {
  const { formatMessage } = useIntl();

  const { getStep4, handleStep4Change, user, userRoles } = useFeesBySolutionContext();

  const { attributionModel } = getStep4();

  const handleAttributionModelChange = (option: SelectorOptionPropsInterface) => {
    handleStep4Change({
      attributionModel: option.id,
      attributionModelValue: undefined
    });
  };

  const attributionModelOptions: SelectorOptionPropsInterface[] = [
    {
      id: 'imp_visitrate',
      label: formatMessage({
        defaultMessage: 'Impressions & Visit Rate',
        id: 'feesBySolution.stepFour.attributionModel.options.imp_visitrate'
      })
    },
    {
      id: 'mediafee_visitcost',
      label: formatMessage({
        defaultMessage: 'Media Fee & Visit Cost',
        id: 'feesBySolution.stepFour.attributionModel.options.mediafee_visitcost'
      })
    }
  ];

  const selectedAttributionModel = attributionModelOptions.find(opt => opt.id === attributionModel);
  const attributionModelRatiosPermissions = checkUserResourcePermissions('attributionModelRatios', user, userRoles);

  return (
    <AttributionModelStyled className="attributionModel">
      <Selector
        className="attributionModelSelector"
        label={formatMessage({
          defaultMessage: 'Attribution model',
          id: 'feesBySolution.stepFour.attributionModel.label'
        })}
        onChange={handleAttributionModelChange}
        options={attributionModelOptions}
        required
        type="simple"
        value={selectedAttributionModel ? [selectedAttributionModel] : []}
      />
      {attributionModelRatiosPermissions && <AttributionModelValues />}
    </AttributionModelStyled>
  );
}

export default AttributionModel;
